import styled from "styled-components";

export const SimCardTrafficDetailWrapper = styled.div`
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    z-index: 100;

    & .ant-tabs-tab {
        padding-left: 10px;
        padding-right: 10px;
    }

    & .ant-tabs-content {
        height: 100%;
    }

    & .ant-tabs-tabpane {
        height: 100%;
    }
`;

export const TitleBar = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 0px 20px 0px;
`;

export const GoBackWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const GoBackText = styled.span`
    margin-left: 5px;
    font-size: 14px;
`;

export const TitleText = styled.div`
    margin-left: 20px;
    font-size: 18px;
`;

export const InfoCard = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;
`;

export const InfoColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const InfoRow = styled.div`
    display: flex;
    align-items: stretch;
    padding: 10px 0px;
    height: 40px;
    box-sizing: border-box;
`;

export const InfoLabel = styled.div`
    flex: 0 0 120px;
    font-size: 14px;
    color: #888888;
    text-align: right;
    margin-right: 15px;
`;

export const InfoValue = styled.div`
    flex: 1 1 auto;
    font-size: 14px;
    color: #333;
`;

export const ChartsWrapper = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-height: 0;
`;

export const ChartCard = styled.div`
    flex: 0 0 auto;
    padding: 20px;
`;

export const ChartTitle = styled.h3`
    margin: 0 0 15px 0;
    font-size: 16px;
    font-weight: bold;
    color: #333;
`;

export const ChartContainer = styled.div`
    width: 100%;
    height: 400px;
`;

export const DateRangeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px ;

    & .ant-btn {
        padding: 15px 20px;
    }
`;

export const TrafficUsageText = styled.div`
    display: inline-block;
    width: 40px;
    text-align: right;
`;
